module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/en/alex-5a32af021c88af2dd0588c8049d7c3dd.jpg";